export default __webpack_public_path__ + "static/media/539.c1c94e7d.png";